import { Component, Input, ElementRef, OnInit, Renderer2, HostBinding } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss']
})
export class SkeletonComponent  {
  @Input() type: 'block' | 'text' = 'block'; // Determines the type of the skeleton element
  @Input() height: string | number = '100%';           // Height of the skeleton element
  @Input() width: string | number = '100%';          // Width of the skeleton element
  @Input() borderRadius: string | number = '4px';    // Border radius for block elements
  @Input() additionalClasses: string[] = [];
  @Input() additionalElementClasses: string[] = [];
  @Input() symbolsCount: number = 50;
  @Input() lineHeight?: number;
  @Input() fontSize?: number;
  @HostBinding('class.text-skeleton') 
  get isTextSkeleton(): boolean {
    return this.type === 'text';
  }

  private skeletonFontCoef = 1.6;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  initTextElement(){
    const element = this.el.nativeElement;
    const computedStyle = getComputedStyle(element);

    // Compute or use input for line height
    const lineHeight = this.lineHeight ? this.lineHeight : parseFloat(computedStyle.lineHeight);

    // Compute or use input for font size
    const fontSize = this.fontSize
      ? this.fontSize / this.skeletonFontCoef
      : parseFloat(computedStyle.fontSize) / this.skeletonFontCoef;

    // Apply styles
    this.renderer.setStyle(element, 'line-height', `${lineHeight}px`);
    this.renderer.setStyle(element, 'font-size', `${fontSize}px`);
  }

  commonInit() {
    const element = this.el.nativeElement;
     // Add any additional classes
     if (this.additionalClasses?.length) {
      this.additionalClasses.forEach(className => {
        this.renderer.addClass(element, className);
      });
    }
    
    if (this.additionalClasses?.length) {
      this.additionalClasses.forEach(className => {
        this.renderer.addClass(element, className);
      });
    }
  }

  initBlockElement(){
    const element = this.el.nativeElement;

    // Set width and height
    if (this.width) {
      this.renderer.setStyle(element, 'width', typeof this.width === 'number' ? `${this.width}px` : this.width);
    }
    if (this.height) {
      this.renderer.setStyle(element, 'height', typeof this.height === 'number' ? `${this.height}px` : this.height);
    }
  }

  ngOnInit(): void {
    this.commonInit()

    if(this.type === 'text')
      this.initTextElement();
    else
      this.initBlockElement();
  }

  getItemDimension(value: string | number) {
    return (typeof value === 'number' ? value + 'px' : value)
  }
}